<template>
  <span class="vv-bubble">
    <input
      type="radio"
      :disabled="disabled"
      :name="name"
      :value="value"
      :id="value"
      :checked="checked"
      @change="onChange"
    />
    <label style="cursor:default" :for="value">{{ label }}</label>
  </span>
</template>

<script>
export default {
  name: 'VvRadioBubble',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    name: String,
    value: String | Number,
    label: String,
    modelValue: String | Array | Number,
    disabled: Boolean
  },
  computed: {
    checked() {
      return Array.isArray(this.modelValue)
        ? this.modelValue.includes(this.value)
        : this.modelValue === this.value
    }
  },
  methods: {
    onChange(event) {
      this.$emit('change', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/vv-bubble.scss';
</style>
